import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";
import { rtlRotate180 } from "plos/src/styles/utils.css";

export const arrowStyle = style([
  rtlRotate180,
  {
    fill: vars.colors.onPrimary,
  },
]);

const controlArrowStyle = style({
  width: 10,
  height: 10,
});

export const controlArrowLeftStyle = style([
  controlArrowStyle,
  {
    marginInlineEnd: "0.5rem",
  },
]);

export const controlArrowRightStyle = style([
  controlArrowStyle,
  {
    marginInlineStart: "0.5rem",
  },
]);
